import React from 'react';
import { Btn } from 'components/btn/Btn';
import classname from 'classnames';

export interface BaseNotificationProps {
    title: React.ReactNode;
    buttonTitle?: string;
    buttonAction?: () => void;
    className?: string;
}

export const BaseNotification = ({
    title,
    buttonTitle,
    buttonAction,
    className = '',
}: BaseNotificationProps) => {
    return (
        <div
            className={classname(
                'border rounded-xl border-l-4 py-4 px-5 shadow-md flex flex-col gap-3 sm:gap-0 sm:flex-row justify-between',
                className
            )}
        >
            <div>{title}</div>
            {buttonTitle && (
                <div className="mt-2 sm:mt-0 w-24 ml-6 sm:ml-0 sm:w-auto">
                    <Btn isSecondary onClick={buttonAction}>
                        {buttonTitle}
                    </Btn>
                </div>
            )}
        </div>
    );
};
